module.exports = __webpack_public_path__ + "assets/img/healthcareSolutions-high.13a5603b.png";